import p1 from "../img/partner1.svg";
import p2 from "../img/partner2.svg";
import p3 from "../img/partner3.svg";
import p4 from "../img/partner4.svg";
import p5 from "../img/partner5.svg";
import p6 from "../img/partner6.svg";
const OffPartnerData = [
  {
    id: 1,
    src: p1,
  },
  {
    id: 2,
    src: p2,
  },
  {
    id: 3,
    src: p3,
  },
  {
    id: 4,
    src: p4,
  },
  {
    id: 5,
    src: p5,
  },
  {
    id: 6,
    src: p6,
  },
];
export default OffPartnerData;
